import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Snowfall from 'react-snowfall';
import { Home, Documentation } from './pages';
import './App.css';

function App() {
  const isDecember = new Date().getMonth() === 11; // December is month 11 (0-indexed)
  const isJanuary = new Date().getMonth() === 0;   // January is month 0 (0-indexed)

  return (
    <Router>
      <div className="App min-h-screen bg-dark-950">
        {(isDecember || isJanuary) && (
          <Snowfall
            style={{
              position: 'fixed',
              width: '100vw',
              height: '100vh',
              zIndex: 9999,
              pointerEvents: 'none',
            }}
            snowflakeCount={50}
          />
        )}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/docs" element={<Documentation />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
